import * as types from './actionTypes';  
import messageDetailApi from '../api/messageDetailApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doMessageDetail(url) {

  return {
    type: types.DO_MESSAGE_DETAIL,
    url
  };
}

export function doMessageDetailRes(data) {  
  return {
    type: types.DO_MESSAGE_DETAIL_RES, 
    data
  };
}

export function fetchMessageDetail(url) {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      messageDetailApi.doMessageDetail(url).then(data => {
        dispatch(doMessageDetailRes(data));
        dispatch(doMessageDetailRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          })
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
}

